import { ArrayUtil } from './ArrayUtil';

export function TestUtil() {}

//to fix issue with arguments.callee.caller.name
//interface Function
//{
//	name: string;
//}

//FINDME:
/** @deprecated */
TestUtil.SHOW_WARNINGS = true;
TestUtil._startTime = undefined as any;
TestUtil._previousTime = undefined as any;
TestUtil._previousMarker = undefined;
TestUtil._previousMarkerCount = 1;

TestUtil.warn = function (e, ctx = '') {
  if (e.stack) console.warn(ctx, e.stack);
  else console.warn(ctx, new Error(e).stack);
};

/**
 * @deprecated use `@suntex.core/logging`
 */
TestUtil.log = function (...a) {
  if (arguments.length > 0) {
    const args = Array.prototype.slice.call(arguments);
    const str = args.join(', ');
    console.log(str);
  } else {
    console.log('*** ' + arguments.callee.caller.name + ' ***');
  }
};

TestUtil.logObject = function (o) {
  console.log(o);
};

//TestUtil.getName = function ()
//{
//	if(o==null || !("name" in o) || o==o.root)return "";
//	else return TestUtil.getName(o.parent)+"."+o.name;
//}

TestUtil.resetTimer = function () {
  TestUtil._startTime = new Date();
  TestUtil._previousTime = TestUtil._startTime;
};

TestUtil.logElapsedTime = function (marker?) {
  marker = marker || arguments.callee.caller.name;

  const currentTime = new Date() as any;
  const totalElapsed = currentTime - TestUtil._startTime;
  const lastElapsed = currentTime - TestUtil._previousTime;

  if (TestUtil._previousMarker == marker) {
    marker += '(' + ++TestUtil._previousMarkerCount + ')';
  } else {
    TestUtil._previousMarker = marker;
    TestUtil._previousMarkerCount = 1;
  }

  TestUtil.log(
    'Time elapsed: ' +
      TestUtil.fixedLength(marker, 20, true, true) +
      ' :: ' +
      TestUtil.fixedLength(totalElapsed, 8, true) +
      ' ms ( +' +
      lastElapsed +
      ' )',
  );
  TestUtil._previousTime = currentTime;
};

//only works for ints
TestUtil.repeatFunctionTest = function (func, args, repeat?) {
  repeat = repeat || 1000;
  const arr = ArrayUtil.generateWithFunction(repeat, func, null, args);
  const tally = ArrayUtil.tally(arr);
  const ratios = ArrayUtil.ratios(tally);
  TestUtil.log(
    TestUtil.fixedLength('value', 10),
    TestUtil.fixedLength('tally', 10),
    'ratio',
  );
  TestUtil.log('-----------------------------------------------------------');
  for (const i in tally) {
    TestUtil.log(
      TestUtil.fixedLength(i, 10),
      TestUtil.fixedLength(tally[i], 10),
      ratios[i],
    );
  }
};

TestUtil.fixedLength = function (str, length, alignRight?, truncate?) {
  str = '' + str;
  //if(!Calculator.isDefined(truncate)) truncate = true;

  if (str.length == length) {
    return str;
  } else if (str.length > length) {
    if (truncate) return str.substr(0, length);
    else return str;
  } else {
    const spaces = ArrayUtil.fill(null, ' ', length - str.length);
    if (alignRight) return ArrayUtil.join(spaces, '') + str;
    else return str + ArrayUtil.join(spaces, '');
  }
};

TestUtil.resetTimer();
